import { render } from "./OfferHighlight.vue?vue&type=template&id=3658d275"
import script from "./OfferHighlight.vue?vue&type=script&lang=js"
export * from "./OfferHighlight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__